import React from "react";
import BeerItem from "./beeritem";
import Particles from 'react-particles-js';
import heartSVG from '../../../../images/heart.png'
import woodBackground from '../../../../images/wood-background.jpg'

let valentinesParticleParams = {
  "particles": {
    "number": {
      "value": 43,
      "density": {
        "enable": true,
        "value_area": 800
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "image",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": heartSVG,
        "width": 200,
        "height": 200
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 35,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 40,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": false,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 1,
      "direction": "top",
      "random": false,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": false,
        "mode": "repulse"
      },
      "onclick": {
        "enable": false,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 400,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
}

let normalParticleParams = {
  "particles": {
    "number": {
      "value": 80,
      "density": {
        "enable": true,
        "value_area": 800
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": "img/github.svg",
        "width": 100,
        "height": 100
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 12.02559045649142,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 40,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": false,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 4,
      "direction": "top",
      "random": true,
      "straight": true,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": false,
        "mode": "repulse"
      },
      "onclick": {
        "enable": false,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 400,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
}

class T1beerlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content:props.content,
      normalParticleParams:normalParticleParams,
      valentinesParticleParams:valentinesParticleParams
    };
  }

  updateBeers(beer){
    // let beers = this.props.content.beers;
    // this.setState({beers})
  }

  componentDidMount(){
    let isVDay = false;
    setInterval(()=>{
      let todayDay = new Date();
      if(todayDay.getDate() === 14 && todayDay.getMonth() === 1){
        console.log('its valentines day!')
        isVDay = true;
      } else {
        isVDay = false;
      }
      this.setState({
        valentinesDay:isVDay
      })
    },5000)
    this.setState({
      content:[{prices:["hello world"]}],
      valentinesDay:isVDay
    })
  };

  componentWillReceiveProps(props){
    this.setState({content:props.content})
  }

  render() {

    let listBeers;
    if(this.state.content && this.state.content.beers){
      let beers = this.state.content.beers;
      listBeers = beers.map((beer,index) =>
        <BeerItem key={index} index={index} beer={beer} onBeerUpdate={this.updateBeers.bind(this)}/>
      );
    }

    return (
      <div>
        <div className="t1-beerlist-container">
          <div className="t1-beerlist-header-image">
            {this.state.valentinesDay === false &&
              <Particles params={this.state.normalParticleParams} height="25vh" className="t1-beerlist-canvas-container"/>
            }
            {this.state.valentinesDay === true &&
              <Particles params={this.state.valentinesParticleParams} height="25vh" className="t1-beerlist-canvas-container"/>
            }
            <div className="t1-beer-list-header-text">
              <h1>
                OUR BEERS
              </h1>
            </div>
          </div>
          <div className="t1-beerlist-list-container" style={{backgroundImage:'url(' + woodBackground + ')'}}>
            {listBeers}
          </div>
        </div>
      </div>
    );
  }
}

export default T1beerlist;



// WEBPACK FOOTER //
// ./src/components/application/templates/t1-beerlist/index.js